import { jimoTrackerInit } from '@shared/jimo-tracker-sdk';
import type { Options } from '@shared/jimo-tracker-sdk/type';

/**
 * 注册全局方法
 * @param opts
 */
export function setupJimoTrackerSdk(opts: Options = {}) {
  jimoTrackerInit(opts);
}
